module.exports = __webpack_public_path__ + "img/20300____-26.prt.152bf2ff.jpg";